import generated from '../../content/blog-posts.generated.json';

export type BlogPost = {
  slug: string;
  title: string;
  description: string;
  pubDate: string;
  author: string;
  heroSrc: string;
  heroAlt: string;
  html: string;
  lead: string;
};

export type BlogManifest = {
  generatedAt: string | null;
  brand: string;
  reason?: string;
  legacyRedirects: Record<string, string>;
  posts: BlogPost[];
};

export const LEGACY_BLOG_SLUG = 'ai-travel-itinerary-planner';

export const blogManifest = generated as BlogManifest;

export function getBlogPost(slug: string): BlogPost | undefined {
  return blogManifest.posts.find((post) => post.slug === slug);
}

export function resolveBlogSlug(slug: string): string {
  return blogManifest.legacyRedirects[slug] || slug;
}

export function formatBlogPubDate(pubDate: string): string {
  const match = pubDate.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!match) return pubDate;
  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  return new Intl.DateTimeFormat('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC',
  }).format(new Date(Date.UTC(year, month - 1, day)));
}
